var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "loading" },
    [_c("Circle2", { staticClass: "chart-spinner" }), _vm._v("Loading... ")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }